/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : EELinkPage.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState, useCallback, useRef } from "react";
import ComponentLinkTemplate from "./ComponentLinkTemplate";
import CustomToolTip from "../../../infoButton/CustomToolTip";
import CustomSearchbarWithApiV2 from "../../common/searchBar/CustomSearchbarWithApiV2";
import { componentStyle } from "../../../../config/appTheme";
import CustomSelectV2 from "../../common/select/CustomSelectV2";
import {
  adminSettingsAPI,
  HandleApiActions,
  labCar,
} from "../../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CustomDialogBoxV2 from "../../common/customDialogBox/CustomDialogBoxV2";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import RefreshIcon from "@mui/icons-material/Refresh";
import AISuggestionDialogContainer from "../../SmartMatchingDialogContainer/AiSuggestionDialogContainer";
import { ENTITY } from "../../SmartMatchingDialogContainer/constants/entityTypes";
import RecreateLinkDialog from "./RecreateLinkDialog";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModuleViewMoreDialog from "../../dashboard/pages/tickets/ModuleViewMoreDialog";

function EELinkPage({ onBeforeSmartMatch }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedProjectDetails = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );

  const selectedSingleVariantDetails = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails,
  );

  const { networkInterfacesEE } = useSelector(
    (state) => state.networkInterfacesReducer,
  );
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const zoneFromurl = queryParams.get("selectedZone");
  const ee_idFromUrl = queryParams.get("ee_id");

  const [eeComponentsMainList, setEEComponentsMainList] = useState([]);
  const [eeMainCount, setEEMainCount] = useState(0);
  const [eeLinkCount, setEELinkCount] = useState(0);
  const [projectID, setProjectID] = useState(null);
  const [variantID, setVariantID] = useState(null);
  const [selectedZoneMain, setSelectedZoneMain] = useState(null);
  const [selectedZoneLinked, setSelectedZoneLinked] = useState(null);
  const [leftPage, setLeftPage] = useState(1);
  const [rightPage, setRightPage] = useState(1);
  const rowsPerPage = 25;
  const [zoneMainOptionsList, setZoneMainOptionsList] = useState([]);
  const [zoneLinkedOptionsList, setZoneLinkedOptionsList] = useState([]);
  const [selectedProjectIsZonal, setSelectedProjectIsZonal] = useState(false);
  const [selectedProjectZonesList, setSelectedProjectZonesList] = useState([]);
  const [modifiedEEComponentList, setModifiedEEComponentList] = useState([]);
  const [modifiedEEComponentLinkList, setModifiedEEComponentLinkList] =
    useState([]);
  const [selectedMainEEDetails, setSelectedMainEEDetails] = useState(null);
  const [eeComponentsLinkedList, setEEComponentsLinkedList] = useState([]);
  // Store intersections in a ref to avoid unused-state warnings
  const selectedEELinkedListRef = useRef([]);
  const [selectedNetworkItem, setSelectedNetworkItem] = useState(null);
  const [networkDialogOpen, setNetworkDialogOpen] = useState(false);
  const [selectedNetworkInterface, setSelectedNetworkInterface] =
    useState(null);
  const [selectedComponent, setSelectedComponent] = useState(null);
  const [linkApiProps, setLinkApiProps] = useState(null);
  const [apiAction, setApiAction] = useState("");
  const [apiDataKey, setApiDataKey] = useState("");
  const [moduleViewMoreType, setModuleViewMoreType] = useState("");
  const [isEEDialogOpen, setIsEEDialogOpen] = useState(false);
  const [actionType2DialogOpen, setActionType2DialogOpen] = useState(false);
  const [pendingEEActionDialogOpen, setPendingEEActionDialogOpen] =
    useState(false);
  const [selectedPendingEEAction, setSelectedPendingEEAction] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [eeGetTriggerMain] = useState(false);
  const eeRequestCounter = useRef(0);
  const leftZoneTimerRef = useRef(null);
  const rightZoneTimerRef = useRef(null);

  /* Smart-matching states */
  const [openAISuggestion, setOpenAISuggestion] = useState(false);
  const [showSmartMatchDialog, setshowSmartMatchDialog] = useState(false);
  const [componentToBeMatched, setComponentToBeMatched] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState(null);

  // recreate states
  const [openEELinkRecreateDialog, setOpenEELinkRecreateDialog] =
    useState(false);
  const [recreateEELinkList, setRecreateEELinkList] = useState([]);
  const [selectedRecreateEEForLink, setSelectedRecreateEEForLink] =
    useState(null);

  const handleSmartMatchRequest = async (componentDetails) => {
    console.log(
      "handleSmartMatchRequest called for componentName:",
      componentDetails?.description,
    );
    // if (onBeforeSmartMatch) {
    //   const refreshResp = await onBeforeSmartMatch();

    //   if (refreshResp?.error) {
    //     console.warn("KG refresh failed, continuing anyway");
    //     // optionally return here if you want to BLOCK
    //   }
    // }
    const componentName = componentDetails?.description;
    if (componentName?.length > 0) {
      setComponentToBeMatched([componentName]);
    }
    setshowSmartMatchDialog(true);
    setOpenAISuggestion(true);
    setSelectedEntity({
      source: [
        {
          entityType: ENTITY.TYPE.EE,
          entityId: componentDetails?.ee_id,
        },
      ],
      targetEntityTypes: [ENTITY.TYPE.EE],
      topK: 5,
      minConfidence: 0.1,
      description: componentName,
    });
  };

  const getEEMainComponentsList = useCallback(
    async ({
      projectId,
      zonePosition,
      variantId,
      pageNo = 1,
      pageSize = rowsPerPage,
    }) => {
      let apiDetails = labCar.get_ee_components_new;
      const reqId = ++eeRequestCounter.current;

      const resp = await dispatch(
        HandleApiActions({
          ...apiDetails,
          params: {
            project_id: projectId,
            status: true,
            variant_id: variantId,
            ...(zonePosition ? { zone_position: zonePosition } : {}),
            page_number: pageNo,
            page_size: pageSize,
          },
          show_toast: false,
        }),
      );

      if (reqId !== eeRequestCounter.current) return resp;

      if (resp.error) {
        setEEComponentsMainList([]);
        setEEMainCount(0);
      } else {
        setEEComponentsMainList(resp.data);
        setEEMainCount(resp.total_count || resp.data?.length || 0);
      }
      return resp;
    },
    [dispatch],
  );

  const getEEIntersectionsList = useCallback(
    async ({ projectId, eeId, variantId }) => {
      if (projectId && eeId) {
        let apiDetails = labCar.get_ee_intersections;

        const resp = await dispatch(
          HandleApiActions({
            ...apiDetails,
            params: {
              project_id: Number(projectId),
              status: true,
              variant_id: Number(variantId),
              ...(eeId && { ee_id: Number(eeId) }),
            },
            show_toast: false,
          }),
        );

        if (resp.error) {
          selectedEELinkedListRef.current = [];
        } else {
          selectedEELinkedListRef.current = resp.data;
        }
      }
    },
    [dispatch],
  );

  // recreate function

  const handleRecreateDialogOpen = async (eeDetails) => {
    let parentEELinkResponse = await dispatch(
      HandleApiActions({
        ...labCar.get_parent_ee_link,
        params: {
          project_id: selectedProjectDetails.project_id,
          parent_project_id: selectedProjectDetails.parent_project_id,
          ee_id: eeDetails?.ee_id,
          parent_ee_id: eeDetails?.parent_ee_id,
        },
      }),
    );
    console.log("--parentEELinkResponse--", parentEELinkResponse);
    if (!parentEELinkResponse?.error) {
      let responseList = parentEELinkResponse?.data;
      // create data to render in table
      let tableRows = responseList.map((ee) => {
        return {
          id: ee.ee_id,
          component: {
            primary: {
              key: "Number:",
              value: ee.assembly_number,
            },
            secondary: [
              {
                key: "Description:",
                value: ee.description,
              },
              {
                key: "version:",
                value: ee.version,
              },
            ],
          },
          raw: ee,
        };
      });
      console.log("----tableRows---", tableRows);
      setRecreateEELinkList(tableRows);
    } else {
      setRecreateEELinkList([]);
    }
    setOpenEELinkRecreateDialog(true);
  };

  const closeRecreateDialog = () => {
    console.log("--closeRecreateDialog--");
    setOpenEELinkRecreateDialog(false);

    // Get EE Components Main List
    if (
      selectedProjectIsZonal &&
      projectID &&
      selectedZoneMain &&
      selectedSingleVariantDetails &&
      selectedSingleVariantDetails?.variant_id
    ) {
      getEEMainComponentsList({
        variantId: selectedSingleVariantDetails?.variant_id,
        projectId: projectID,
        zonePosition: selectedZoneMain,
      });
    }
    // Get EE Components Linked List
    if (
      selectedProjectIsZonal &&
      projectID &&
      selectedZoneLinked &&
      selectedSingleVariantDetails &&
      selectedSingleVariantDetails?.variant_id
    ) {
      getEELinkedComponentsList({
        projectId: projectID,
        variantId: selectedSingleVariantDetails?.variant_id,
        zonePosition: selectedZoneLinked,
      });
    }
    // Get EE Components Main & Linked List, When the selected project is changed
    if (
      !selectedProjectIsZonal &&
      projectID &&
      selectedSingleVariantDetails &&
      selectedSingleVariantDetails?.variant_id
    ) {
      getEEMainLinkedComponentsList({
        projectId: projectID,
        variantId: selectedSingleVariantDetails?.variant_id,
      });
    }
    /* Get EE Intersections List  */
    getEEIntersectionsList({
      variantId: Number(selectedSingleVariantDetails?.variant_id),
      projectId: Number(projectID),
      eeId: Number(selectedMainEEDetails?.ee_id),
    });
  };

  const handleOnClickRecreateLink = (selectedEE) => {
    setNetworkDialogOpen(true);
    setSelectedRecreateEEForLink(selectedEE);
    console.log("---handleOnClickRecreateLink---", selectedEE);
    setSelectedNetworkInterface(selectedEE?.parent_network_interface);
  };

  const handleRecreateLink = async () => {
    const reqObj = {
      child: {
        ee_id: selectedRecreateEEForLink.ee_id,
      },
      current_time: new Date().toISOString(),
      module_type: "ecu",
      network_interface: selectedNetworkInterface,
      parent: { ee_id: selectedMainEEDetails?.ee_id },
      project_id: selectedProjectDetails?.project_id,
      variant_id: selectedSingleVariantDetails?.variant_id,
      parent_parent_ee_id: selectedMainEEDetails?.parent_ee_id,
      parent_child_ee_id: selectedRecreateEEForLink?.parent_ee_id,
      session_id: selectedRecreateEEForLink?.session_id,
    };
    console.log("---handleRecreateLink---", reqObj);
    // hit post api for recreate link
    let apiDetails = labCar.recreate_ee_link;
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        params: reqObj,
        show_toast: true,
      }),
    );
    console.log("---recreate_ee_link---", resp);
    if (!resp.error) {
      setNetworkDialogOpen(false);
      handleRecreateDialogOpen(selectedMainEEDetails);
    }
  };

  useEffect(() => {
    dispatch(
      HandleApiActions({
        ...adminSettingsAPI.get_ee_network_interfaces,
        params: {
          network_type: "ecu",
        },
        show_toast: false,
      }),
    );
  }, [dispatch]);

  const getEELinkedComponentsList = useCallback(
    async ({
      projectId,
      zonePosition,
      variantId,
      pageNo = 1,
      pageSize = rowsPerPage,
    }) => {
      let apiDetails = labCar.get_ee_components_new;
      const reqId = ++eeRequestCounter.current;

      const resp = await dispatch(
        HandleApiActions({
          ...apiDetails,
          params: {
            project_id: projectId,
            status: true,
            variant_id: variantId,
            ...(zonePosition ? { zone_position: zonePosition } : {}),
            page_number: pageNo,
            page_size: pageSize,
          },
          show_toast: false,
        }),
      );

      if (reqId !== eeRequestCounter.current) return resp;

      if (resp.error) {
        setEEComponentsLinkedList([]);
        setEELinkCount(0);
      } else {
        setEEComponentsLinkedList(resp.data);
        setEELinkCount(resp.total_count || resp.data?.length || 0);
      }
      return resp;
    },
    [dispatch],
  );

  const getEEMainLinkedComponentsList = useCallback(
    async ({ projectId, variantId, pageNo = 1, pageSize = rowsPerPage }) => {
      let apiDetails = labCar.get_ee_components_new;
      const reqId = ++eeRequestCounter.current;

      const resp = await dispatch(
        HandleApiActions({
          ...apiDetails,
          params: {
            status: true,
            project_id: projectId,
            variant_id: variantId,
            page_number: pageNo,
            page_size: pageSize,
          },
          show_toast: false,
        }),
      );

      if (reqId !== eeRequestCounter.current) return resp;

      if (resp.error) {
        setEEComponentsMainList([]);
        setEEComponentsLinkedList([]);
        setEEMainCount(0);
        setEELinkCount(0);
      } else {
        setEEComponentsMainList(resp.data);
        setEEComponentsLinkedList(resp.data);
        setEEMainCount(resp.total_count || resp.data?.length || 0);
        setEELinkCount(resp.total_count || resp.data?.length || 0);
      }
      return resp;
    },
    [dispatch],
  );

  const handleOpenNetworkInterface = (item) => {
    setSelectedNetworkItem(item);
    setNetworkDialogOpen(true);
  };

  const handleDialogOpen = () => {
    console.log("handleDialogOpen");
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const updateChangesAndClose = () => {
    handleDialogClose();
    navigate(`/dashboard/v2/link?selectedZone=${selectedZoneMain}`); // try {
    //   const params = new URLSearchParams(location.search);
    //   params.delete("swm_id");
    //   params.delete("ee_id");
    //   // params.delete("selectedZone");
    //   params.delete("zone");
    //   params.delete("tabFromurl");
    //   // Keep user on Software Module tab
    //   params.set("tab", "0");
    //   navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    // } catch (e) {
    //   // Fallback: navigate to same path with only tab preserved
    //   navigate(`${location.pathname}?tab=0`, { replace: true });
    // }
  };

  const confirmUpdateAndRedirect = async () => {
    // Create the request object
    const reqObj = {
      current_time: new Date().toISOString(),
      project_id: Number(projectID),
      variant_id: selectedSingleVariantDetails?.variant_id,
      ee_id: Number(selectedMainEEDetails?.ee_id),
      is_dependency_linking: true,
      module_type: "LINKING",
    };
    try {
      // Dispatch the update action type API action
      const response = await dispatch(
        HandleApiActions({
          ...labCar.update_action_type,
          params: reqObj,
          show_toast: false,
        }),
      );
      navigate(`/dashboard/v2/link?selectedZone=${selectedZoneMain}`);
      // getEEMainLinkedComponentsList({
      //   projectId: projectID,
      //   variantId: selectedSingleVariantDetails?.variant_id,
      // });
      handleDialogClose();
      handleActionType2DialogOpen();
      // Handle successful edit
      if (!response.error) {
      }
    } catch (error) {
      console.error("Failed to update action type", error);
    }
  };
  const handleEEComponentLink = (selectedLinkedEEDetails) => {
    if (
      projectID &&
      selectedMainEEDetails &&
      selectedMainEEDetails?.ee_id &&
      selectedLinkedEEDetails &&
      selectedLinkedEEDetails?.ee_id &&
      selectedSingleVariantDetails &&
      selectedSingleVariantDetails?.variant_id
    ) {
      let currentTime = new Date().toISOString();

      dispatch(
        HandleApiActions({
          ...labCar.link_ee_component,
          params: {
            project_id: Number(projectID),
            variant_id: Number(selectedSingleVariantDetails?.variant_id),
            parent: {
              ee_id: Number(selectedMainEEDetails?.ee_id),
            },
            child: {
              ee_id: Number(selectedLinkedEEDetails?.ee_id),
            },
            current_time: currentTime,
            network_interface: selectedNetworkInterface,
            module_type: "ecu",
          },
          show_toast: true,
        }),
      ).then(() => {
        // Get EE Components Main List
        if (
          selectedProjectIsZonal &&
          projectID &&
          selectedZoneMain &&
          selectedSingleVariantDetails &&
          selectedSingleVariantDetails?.variant_id
        ) {
          getEEMainComponentsList({
            variantId: selectedSingleVariantDetails?.variant_id,
            projectId: projectID,
            zonePosition: selectedZoneMain,
          });
        }
        // Get EE Components Linked List
        if (
          selectedProjectIsZonal &&
          projectID &&
          selectedZoneLinked &&
          selectedSingleVariantDetails &&
          selectedSingleVariantDetails?.variant_id
        ) {
          getEELinkedComponentsList({
            projectId: projectID,
            variantId: selectedSingleVariantDetails?.variant_id,
            zonePosition: selectedZoneLinked,
          });
        }
        // Get EE Components Main & Linked List, When the selected project is changed
        if (
          !selectedProjectIsZonal &&
          projectID &&
          selectedSingleVariantDetails &&
          selectedSingleVariantDetails?.variant_id
        ) {
          getEEMainLinkedComponentsList({
            projectId: projectID,
            variantId: selectedSingleVariantDetails?.variant_id,
          });
        }

        /* Get EE Intersections List  */
        getEEIntersectionsList({
          variantId: Number(selectedSingleVariantDetails?.variant_id),
          projectId: Number(projectID),
          eeId: Number(selectedMainEEDetails?.ee_id),
        });
      });
    }
  };

  const handleCloseNetworkInterface = () => {
    setNetworkDialogOpen(false);
    setSelectedNetworkItem(null);
    setSelectedNetworkInterface(null);
  };
  const handleActionType2DialogOpen = (ecu) => {
    // setSelectedECU(ecu);
    setActionType2DialogOpen(true);
  };

  const handleActionType2DialogClose = () => {
    // navigate(
    //   `/dashboard/v2/type-approval/link?ee_id=${selectedMainEEDetails?.ee_id}&selectedZone=${selectedZoneMain}&tab=ee`
    // );
    setActionType2DialogOpen(false);
  };

  const handlePendingEEActionDialogClose = () => {
    setPendingEEActionDialogOpen(false);
    setSelectedPendingEEAction(null);
  };

  const handleRedirectionToTypeApproval = () => {
    navigate(
      `/dashboard/v2/type-approval/link?ee_id=${selectedMainEEDetails?.ee_id}&zone=${selectedZoneMain}&tab=0`,
    );
    setActionType2DialogOpen(false);
  };

  const handleRedirectionToEEComponents = () => {
    const selectedEE = selectedPendingEEAction || selectedMainEEDetails;
    const selectedZoneDetails = selectedProjectZonesList?.find(
      (zone) => Number(zone?.position) === Number(selectedZoneMain),
    );
    const params = new URLSearchParams();

    if (selectedEE?.ee_id) {
      params.set("ee_id", selectedEE.ee_id);
    }
    params.set("actionMode", "eeComponentAction");
    if (selectedZoneMain) {
      params.set(
        "selectedZone",
        selectedZoneDetails?.zone_name || selectedZoneMain,
      );
      params.set("zonePosition", selectedZoneMain);
    }
    if (leftPage) {
      params.set("page", leftPage);
    }

    navigate(`/dashboard/v2/EESWM?${params.toString()}`);
    handlePendingEEActionDialogClose();
  };

  const handleEEComponentUnLink = (selectedLinkedEEDetails) => {
    if (
      projectID &&
      selectedMainEEDetails &&
      selectedMainEEDetails?.ee_id &&
      selectedLinkedEEDetails &&
      selectedLinkedEEDetails?.ee_id &&
      selectedSingleVariantDetails &&
      selectedSingleVariantDetails?.variant_id
    ) {
      let currentTime = new Date().toISOString();

      dispatch(
        HandleApiActions({
          ...labCar.unlink_ee_component,
          params: {
            project_id: Number(projectID),
            variant_id: Number(selectedSingleVariantDetails?.variant_id),
            ee_id: Number(selectedMainEEDetails?.ee_id),
            removing_ee_id: Number(selectedLinkedEEDetails?.ee_id),
            current_time: currentTime,
          },
          show_toast: true,
        }),
      ).then(() => {
        // Get EE Components Main List
        if (
          selectedProjectIsZonal &&
          projectID &&
          selectedZoneMain &&
          selectedSingleVariantDetails &&
          selectedSingleVariantDetails?.variant_id
        ) {
          getEEMainComponentsList({
            variantId: selectedSingleVariantDetails?.variant_id,
            projectId: projectID,
            zonePosition: selectedZoneMain,
          });
        }
        // Get EE Components Linked List
        if (
          selectedProjectIsZonal &&
          projectID &&
          selectedZoneLinked &&
          selectedSingleVariantDetails &&
          selectedSingleVariantDetails?.variant_id
        ) {
          getEELinkedComponentsList({
            variantId: selectedSingleVariantDetails?.variant_id,
            projectId: projectID,
            zonePosition: selectedZoneLinked,
          });
        }
        // Get EE Components Main & Linked List, When the selected project is changed
        if (
          !selectedProjectIsZonal &&
          projectID &&
          selectedSingleVariantDetails &&
          selectedSingleVariantDetails?.variant_id
        ) {
          getEEMainLinkedComponentsList({
            projectId: projectID,
            variantId: selectedSingleVariantDetails?.variant_id,
          });
        }

        /* Get EE Intersections List  */
        getEEIntersectionsList({
          variantId: Number(selectedSingleVariantDetails?.variant_id),
          projectId: Number(projectID),
          eeId: Number(selectedMainEEDetails?.ee_id),
        });
      });
    }
  };

  const handleNetworkInterfaceSelect = (item) => {
    // Here, you would send the structure to the API or update state as needed
    // For now, just close the dialog and log the selection
    if (openEELinkRecreateDialog) {
      handleRecreateLink();
    } else {
      handleEEComponentLink(item);
    }
    setNetworkDialogOpen(false);
    setSelectedNetworkItem(null);
    setSelectedNetworkInterface(null);
    // TODO: Replace with actual API call
    console.log("Selected item:", selectedNetworkItem);
    console.log("Selected network interface:", selectedNetworkInterface);
    // Example: dispatch(createNetworkLink({ item: selectedNetworkItem, interfaceId: selectedNetworkInterface }))
  };

  useEffect(() => {
    setProjectID(selectedProjectDetails?.project_id);
    setDialogOpen(false);
    setComponentToBeMatched([]);
  }, [selectedProjectDetails]);

  useEffect(() => {
    setVariantID(selectedSingleVariantDetails?.variant_id);
    setDialogOpen(false);
    setComponentToBeMatched([]);
  }, [selectedSingleVariantDetails]);

  useEffect(() => {
    setSelectedProjectIsZonal(selectedProjectDetails?.is_zonal);
    setSelectedProjectZonesList(selectedProjectDetails?.project_zones);
  }, [selectedProjectDetails]);

  useEffect(() => {
    // Centralized projects use a shared dataset for both cards; keep pagination in sync.
    if (selectedProjectIsZonal === false) {
      setRightPage(leftPage);
    }
  }, [selectedProjectIsZonal, leftPage]);

  useEffect(() => {
    // Setup zone options when project zones change
    if (selectedProjectIsZonal && selectedProjectZonesList?.length > 0) {
      /* Zone Main Options */
      let filteredZoneMainOptionsList = selectedProjectZonesList
        ?.map((el) => {
          return {
            value: el?.position,
            label: el?.zone_name,
          };
        })
        ?.sort((a, b) => a.label.localeCompare(b.label));
      setZoneMainOptionsList(filteredZoneMainOptionsList);

      /* Zone Linked Options */
      let filteredZoneLinkedOptionsList = selectedProjectZonesList
        ?.map((el) => {
          return {
            value: el?.position,
            label: el?.zone_name,
          };
        })
        ?.sort((a, b) => a.label.localeCompare(b.label));
      setZoneLinkedOptionsList(filteredZoneLinkedOptionsList);

      /* Select zone from URL if available, otherwise select first zone */
      const zoneFromUrlValue = filteredZoneMainOptionsList?.find(
        (zone) => zone.label === zoneFromurl || zone.value === zoneFromurl,
      );

      if (zoneFromUrlValue) {
        setSelectedZoneMain(zoneFromUrlValue?.value);
        setSelectedZoneLinked(zoneFromUrlValue?.value);
      } else if (
        selectedProjectIsZonal &&
        filteredZoneMainOptionsList?.[0]?.value
      ) {
        setSelectedZoneMain(filteredZoneMainOptionsList?.[0]?.value);
        setSelectedZoneLinked(filteredZoneLinkedOptionsList?.[0]?.value);
      }
    }
  }, [selectedProjectZonesList, zoneFromurl, selectedProjectIsZonal]);

  const prevLeftZoneKeyRef = useRef(null);
  useEffect(() => {
    // On zonal projects, fetch main EE list when zone/page changes.
    if (!selectedProjectIsZonal) return;

    const zoneKey = `${projectID || ""}|${variantID || ""}|${
      selectedZoneMain || ""
    }`;
    const zoneChanged = prevLeftZoneKeyRef.current !== zoneKey;
    prevLeftZoneKeyRef.current = zoneKey;

    if (zoneChanged) {
      setSelectedMainEEDetails(null);
      if (leftPage !== 1) setLeftPage(1);
    }

    if (leftZoneTimerRef.current) clearTimeout(leftZoneTimerRef.current);
    if (projectID && variantID && selectedZoneMain) {
      const effectivePage = zoneChanged ? 1 : leftPage;
      leftZoneTimerRef.current = setTimeout(async () => {
        const resp = await getEEMainComponentsList({
          projectId: projectID,
          variantId: variantID,
          zonePosition: selectedZoneMain,
          pageNo: effectivePage,
          pageSize: rowsPerPage,
        });
        if (
          zoneChanged &&
          !resp?.error &&
          Array.isArray(resp?.data) &&
          resp.data.length
        ) {
          setSelectedMainEEDetails(resp.data[0]);
        }
      }, 250);
    }

    return () => {
      if (leftZoneTimerRef.current) {
        clearTimeout(leftZoneTimerRef.current);
        leftZoneTimerRef.current = null;
      }
    };
  }, [
    selectedZoneMain,
    selectedProjectIsZonal,
    projectID,
    variantID,
    leftPage,
    rowsPerPage,
    getEEMainComponentsList,
  ]);

  const prevRightZoneKeyRef = useRef(null);
  useEffect(() => {
    // On zonal projects, fetch linked EE list when zone/page changes.
    if (!selectedProjectIsZonal) return;

    const zoneKey = `${projectID || ""}|${variantID || ""}|${
      selectedZoneLinked || ""
    }`;
    const zoneChanged = prevRightZoneKeyRef.current !== zoneKey;
    prevRightZoneKeyRef.current = zoneKey;

    if (zoneChanged && rightPage !== 1) setRightPage(1);

    if (rightZoneTimerRef.current) clearTimeout(rightZoneTimerRef.current);
    if (projectID && variantID && selectedZoneLinked) {
      const effectivePage = zoneChanged ? 1 : rightPage;
      rightZoneTimerRef.current = setTimeout(() => {
        getEELinkedComponentsList({
          projectId: projectID,
          variantId: variantID,
          zonePosition: selectedZoneLinked,
          pageNo: effectivePage,
          pageSize: rowsPerPage,
        });
      }, 250);
    }

    return () => {
      if (rightZoneTimerRef.current) {
        clearTimeout(rightZoneTimerRef.current);
        rightZoneTimerRef.current = null;
      }
    };
  }, [
    selectedZoneLinked,
    selectedProjectIsZonal,
    projectID,
    variantID,
    rightPage,
    rowsPerPage,
    getEELinkedComponentsList,
  ]);

  useEffect(() => {
    // For centralized projects, let search bars load; still clear selection on switch
    if (selectedProjectIsZonal === false) {
      setSelectedMainEEDetails(null);
    }
  }, [selectedProjectIsZonal]);

  const prevCentralKeyRef = useRef(null);
  useEffect(() => {
    // Centralized: fetch the shared list based on left pagination.
    if (selectedProjectIsZonal !== false || !projectID || !variantID) return;

    const centralKey = `${projectID}|${variantID}`;
    const keyChanged = prevCentralKeyRef.current !== centralKey;
    prevCentralKeyRef.current = centralKey;

    if (keyChanged && leftPage !== 1) setLeftPage(1);

    (async () => {
      const effectivePage = keyChanged ? 1 : leftPage;
      const resp = await getEEMainLinkedComponentsList({
        projectId: projectID,
        variantId: variantID,
        pageNo: effectivePage,
        pageSize: rowsPerPage,
      });
      if (
        (keyChanged || !selectedMainEEDetails) &&
        !resp?.error &&
        Array.isArray(resp?.data) &&
        resp.data.length
      ) {
        setSelectedMainEEDetails(resp.data[0]);
      }
    })();
  }, [
    selectedProjectIsZonal,
    projectID,
    variantID,
    leftPage,
    rowsPerPage,
    getEEMainLinkedComponentsList,
    selectedMainEEDetails,
  ]);

  useEffect(() => {
    /* Get EE Intersections List  */
    if (projectID && selectedMainEEDetails?.ee_id && variantID) {
      getEEIntersectionsList({
        variantId: Number(variantID),
        projectId: Number(projectID),
        eeId: Number(selectedMainEEDetails?.ee_id),
      });
    }
  }, [selectedMainEEDetails, projectID, variantID, getEEIntersectionsList]);

  useEffect(() => {
    // Filter out the selected left component from right side list
    const filteredList = eeComponentsLinkedList.filter(
      (item) => item.ee_id !== selectedMainEEDetails?.ee_id,
    );

    const modifiedList = filteredList.map((item) => {
      const isLinked = item?.linked_ee_ids?.includes(
        selectedMainEEDetails?.ee_id,
      );
      return {
        data: item,
        id: item.ee_id,
        isLinked: isLinked,
        cardStyle: isLinked ? { border: "1px solid #4CAF50" } : {},
        cardDataArray: [
          {
            key: "Assembly No",
            value: (
              <CustomToolTip
                type="string"
                length={50}
                style={{
                  ...componentStyle.font.text,
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}
                title={`Assembly No: ${item?.assembly_number ?? ""}`}
              >
                {`${item?.assembly_number ?? ""}`}
              </CustomToolTip>
            ),
            keyStyle: {
              ...componentStyle.font.text,
              fontWeight: "bold",
            },
            valueStyle: { ...componentStyle.font.text, fontWeight: "bold" },
          },
          {
            key: "Description",
            value: (
              <CustomToolTip
                type="string"
                length={50}
                style={{
                  ...componentStyle.font.text,
                  // fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}
                title={`Description: ${item?.description ?? ""}`}
              >
                {`${item?.description ?? ""}`}
              </CustomToolTip>
            ),
          },
          {
            key: "Version",
            value: (
              <CustomToolTip
                type="string"
                length={50}
                style={{
                  ...componentStyle.font.text,
                  // fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}
                title={`Version: ${item?.version ?? ""}`}
              >
                {`${item?.version ?? ""}`}
              </CustomToolTip>
            ),
          },
        ],
      };
    });
    setModifiedEEComponentLinkList(modifiedList);
  }, [eeComponentsLinkedList, selectedMainEEDetails]);

  useEffect(() => {
    const modifiedList = eeComponentsMainList.map((item) => {
      return {
        data: item,
        id: item.ee_id,
        cardDataArray: [
          {
            key: "Assembly No",
            value: (
              <CustomToolTip
                type="string"
                length={50}
                style={{
                  ...componentStyle.font.text,
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}
                title={`Assembly No: ${item?.assembly_number ?? ""}`}
              >
                {`${item?.assembly_number ?? ""}`}
              </CustomToolTip>
            ),
            keyStyle: { ...componentStyle.font.text, fontWeight: "bold" },
            valueStyle: { ...componentStyle.font.text, fontWeight: "bold" },
          },
          {
            key: "Description",
            value: (
              <CustomToolTip
                type="string"
                length={50}
                style={{
                  ...componentStyle.font.text,
                  // fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}
                title={`Description: ${item?.description ?? ""}`}
              >
                {`${item?.description ?? ""}`}
              </CustomToolTip>
            ),
          },
          {
            key: "Version",
            value: (
              <CustomToolTip
                type="string"
                length={50}
                style={{
                  ...componentStyle.font.text,
                  // fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}
                title={`Version: ${item?.version ?? ""}`}
              >
                {`${item?.version ?? ""}`}
              </CustomToolTip>
            ),
          },
        ],
      };
    });
    setModifiedEEComponentList(modifiedList);
    // Only auto-select first component if no component is currently selected
    if (modifiedList.length && !selectedMainEEDetails) {
      setSelectedMainEEDetails(modifiedList[0].data);
    }
  }, [eeComponentsMainList, selectedMainEEDetails]);

  // const handelClickViewDetails = (e, item) => {
  //   const modules = item?.dependencies?.software_modules || [];
  //   const vehicleFunctions = item?.swm_details?.vehicle_functions;
  //   setSelectedComponent(item);
  //   setApiAction(softwareIntersectionAPI.get_software_intersections);
  //   setLinkApiProps({
  //     swm_id: item?.swm_details?.swm_id,
  //     ee_id: item?.ee_details?.ee_id,
  //   });
  //   setApiDataKey("linked_swm_details");
  //   setModuleViewMoreType("SWM");

  //   // Map the modules to include both module details and their corresponding ee_details
  //   const items2 = modules?.map((module) => ({
  //     swm_id: module?.swm_id,
  //     name: module?.name,
  //     version: module?.version,
  //     description: module?.description,
  //     ee_details: module?.ee_details || [], // Include ee_details in each module
  //   }));

  //   const eeDetails = modules.flatMap((module) => module?.ee_details) || [];

  //   setDialogData({
  //     heading1: `Vehicle Functions`,
  //     items1:
  //       vehicleFunctions?.map((vehicleFunction) => ({
  //         name: vehicleFunction?.name,
  //         abbreviation: vehicleFunction?.abbreviation,
  //       })) || [],
  //     heading2: `Dependent Software Modules`,
  //     items2: items2, // Use the combined items
  //     heading3: `EE Details`,
  //     items3: eeDetails?.map((ee) => ({
  //       ee_id: ee?.ee_id,
  //       assembly_number: ee?.assembly_number,
  //       description: ee?.description,
  //       supplier_name: ee?.supplier_name,
  //       version: ee?.version,
  //     })),
  //   });

  //   toggleDialog(true)();
  // };

  const handleEEViewButtonClick = (item) => {
    console.log(item, "itemitemitem");
    setSelectedComponent({ ee_details: item });
    setApiAction(labCar.get_ee_intersections);
    setLinkApiProps({
      ee_id: item?.ee_id,
    });
    setApiDataKey("linked_ee_details");
    setModuleViewMoreType("EE");
    toggleEEDialog(true)();
  };

  const toggleEEDialog = (newOpen) => () => {
    setIsEEDialogOpen(newOpen);
  };

  const getEEActionTypeTooltip = (actionType) => {
    switch (Number(actionType)) {
      case 1:
        return "Action Pending in EE Component to EE Component linking";
      case 2:
        return "Action Pending in EE Component to Legal linking";
      case 4:
        return "Action required in EE Component Attribute";
      case 5:
        return "Action pending in EE Component Version";
      default:
        return "";
    }
  };

  const handleEEActionTypeClick = (event, item) => {
    event.stopPropagation();
    setSelectedMainEEDetails(item);

    if (Number(item?.action_type) === 1) {
      handleDialogOpen();
    } else if (Number(item?.action_type) === 2) {
      handleActionType2DialogOpen();
    } else if ([4, 5].includes(Number(item?.action_type))) {
      setSelectedPendingEEAction(item);
      setPendingEEActionDialogOpen(true);
    }
  };

  return (
    <Box>
      <ComponentLinkTemplate
        leftCardHeader={
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                // mt: 1,
              }}
            >
              <Typography>Select Component</Typography>
            </Box>
            <Box
              display="flex"
              gap={1}
              sx={{
                width: "100%",
                mt: 0.5,
                // ml: -0.5,
                justifyContent: "space-between",
                alignItems: "center",
                // backgroundColor: "red",
              }}
            >
              <Box sx={{ flex: selectedProjectIsZonal ? "0 0 60%" : "1" }}>
                <CustomSearchbarWithApiV2
                  key={`ee-search-${projectID}-${variantID}-${selectedZoneMain}`}
                  apiAction={labCar.get_ee_components_new}
                  searchKey={"assembly_number"}
                  placeholder={"Search Assembly Number"}
                  triggerApi={eeGetTriggerMain}
                  getDataOnSearch={(data, resp) => {
                    if (resp.error) {
                      setEEComponentsMainList([]);
                    } else {
                      setEEComponentsMainList(resp.data);
                      setEEMainCount(
                        resp.total_count || resp.data?.length || 0,
                      );
                    }
                  }}
                  skipApiCall={
                    !projectID ||
                    !variantID ||
                    (selectedProjectIsZonal && !selectedZoneMain)
                  }
                  skipInitialSearch={true}
                  params={{
                    ...(projectID && variantID
                      ? {
                          project_id: Number(projectID),
                          variant_id: Number(variantID),
                          ...(selectedProjectIsZonal &&
                            selectedZoneMain && {
                              zone_position: selectedZoneMain,
                            }),
                          ...(ee_idFromUrl && { ee_id: Number(ee_idFromUrl) }),
                          status: true,
                          page_number: leftPage,
                          page_size: rowsPerPage,
                        }
                      : {}),
                  }}
                  iconColor={"white"}
                  txtFldStyle={componentStyle.searchField.textField}
                />
              </Box>
              {selectedProjectIsZonal && (
                <Box sx={{ flex: "0 0 38%" }}>
                  <CustomSelectV2
                    label={"Zone"}
                    optionsList={zoneMainOptionsList}
                    selectedValue={selectedZoneMain}
                    handleOnChange={(e) => setSelectedZoneMain(e.target.value)}
                    // enableSearch={true}
                    dark={true}
                    showLabel={false}
                  />
                </Box>
              )}
            </Box>
          </Box>
        }
        leftDataList={modifiedEEComponentList}
        leftHandleSelectedComponent={(selectedObj) => {
          setSelectedMainEEDetails(selectedObj.data);
        }}
        leftSelectedComponentDetails={selectedMainEEDetails}
        leftRenderCardActionIcons={(item) => {
          console.log("item in leftRenderCardActionIcons:", item);
          const actionType = Number(item?.action_type);
          const actionTypeTooltip = getEEActionTypeTooltip(actionType);
          return (
            <Box sx={{ position: "relative" }}>
              <Box
                sx={{
                  position: "absolute",
                  top: 2,
                  right: 2,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5, // space between icons
                }}
              >
                {[1, 2, 4, 5].includes(actionType) && (
                  <CustomToolTip
                    type="component"
                    title={actionTypeTooltip}
                  >
                    <IconButton
                      size="small"
                      sx={{ color: "black", p: 0.5 }}
                      onClick={(event) => handleEEActionTypeClick(event, item)}
                    >
                      <ErrorOutlineIcon sx={{ fontSize: "15px" }} />
                    </IconButton>
                  </CustomToolTip>
                )}
                {item.parent_ee_id && (
                  <CustomToolTip type="component" title="Recreate Link">
                    <IconButton
                      size="small"
                      sx={{ color: "black" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedMainEEDetails(item);
                        handleRecreateDialogOpen(item);
                      }}
                    >
                      <RefreshIcon sx={{ fontSize: "15px", color: "black" }} />
                    </IconButton>
                  </CustomToolTip>
                )}
                {/* New icon (left-most) */}
                <CustomToolTip type="component" title="Initiate Smart-matching">
                  <IconButton
                    size="small"
                    sx={{ color: "black" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedMainEEDetails(item);
                      handleSmartMatchRequest(item);
                    }}
                  >
                    <AutoAwesomeIcon
                      sx={{ fontSize: "15px", color: "black" }}
                    />
                  </IconButton>
                </CustomToolTip>
                <IconButton
                  size="small"
                  sx={{ color: "#000000", p: 0.5 }}
                  onClick={(event) => {
                    handleEEViewButtonClick(item);
                  }}
                >
                  <VisibilityIcon sx={{ fontSize: "15px", color: "black" }} />
                </IconButton>
              </Box>
            </Box>
          );
        }}
        leftPage={leftPage}
        leftRowsPerPage={rowsPerPage}
        leftHandlePageChange={(leftPage) => {
          setLeftPage(leftPage);
        }}
        leftTotalCount={eeMainCount}
        leftCardID={"ee_id"}
        // Right data
        rightCardHeader={
          <Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              // mt={-1}
            >
              <Typography>Link to Component</Typography>
            </Box>
            <Box
              display="flex"
              gap={1}
              sx={{
                width: "100%",
                mt: 0.5,
                // ml: -0.5,
                justifyContent: "space-between",
                alignItems: "center",
                // backgroundColor: "red",
              }}
            >
              <Box sx={{ flex: selectedProjectIsZonal ? "0 0 60%" : "1" }}>
                <CustomSearchbarWithApiV2
                  key={`ee-search-${projectID}-${variantID}-${selectedZoneMain}`}
                  apiAction={labCar.get_ee_components_new}
                  searchKey={"assembly_number"}
                  placeholder={"Search Assembly Number"}
                  getDataOnSearch={(data, resp) => {
                    if (resp.error) {
                      setEEComponentsLinkedList([]);
                    } else {
                      setEEComponentsLinkedList(resp.data);
                      setEELinkCount(
                        resp.total_count || resp.data?.length || 0,
                      );
                    }
                  }}
                  skipApiCall={
                    !projectID ||
                    !variantID ||
                    (selectedProjectIsZonal && !selectedZoneLinked)
                  }
                  skipInitialSearch={true}
                  params={{
                    ...(projectID && variantID
                      ? {
                          project_id: Number(projectID),
                          variant_id: Number(variantID),
                          ...(selectedProjectIsZonal &&
                            selectedZoneLinked && {
                              zone_position: selectedZoneLinked,
                            }),
                          status: "true",
                          page_number:
                            selectedProjectIsZonal === false
                              ? leftPage
                              : rightPage,
                          page_size: rowsPerPage,
                        }
                      : {}),
                  }}
                  iconColor={"white"}
                  txtFldStyle={componentStyle.searchField.textField}
                />
              </Box>
              {selectedProjectIsZonal && (
                <Box sx={{ flex: "0 0 38%" }}>
                  <CustomSelectV2
                    label={"Select Zone"}
                    optionsList={zoneLinkedOptionsList}
                    selectedValue={selectedZoneLinked}
                    handleOnChange={(e) =>
                      setSelectedZoneLinked(e.target.value)
                    }
                    // enableSearch={true}
                    dark={true}
                    showLabel={false}
                  />
                </Box>
              )}
            </Box>
          </Box>
        }
        rightDataList={modifiedEEComponentLinkList}
        rightPage={selectedProjectIsZonal === false ? leftPage : rightPage}
        rightRowsPerPage={rowsPerPage}
        rightHandlePageChange={(nextPage) => {
          if (selectedProjectIsZonal === false) {
            setLeftPage(nextPage);
          } else {
            setRightPage(nextPage);
          }
        }}
        rightTotalCount={eeLinkCount}
        rightCardStyleProp={(item) => item.cardStyle || {}}
        rightRenderCardActionIcons={(item) => {
          return (
            <Box sx={{ position: "relative" }}>
              {selectedMainEEDetails && (
                <CustomToolTip
                  type="component"
                  title={
                    item?.linked_ee_ids?.includes(selectedMainEEDetails?.ee_id)
                      ? "Unlink"
                      : "Link"
                  }
                >
                  <IconButton
                    size="small"
                    sx={{
                      fontSize: "12px",
                      color: "black",
                      position: "absolute",
                      top: 2,
                      right: 2,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (
                        item?.linked_ee_ids?.includes(
                          selectedMainEEDetails?.ee_id,
                        )
                      ) {
                        handleEEComponentUnLink(item);
                      } else {
                        handleOpenNetworkInterface(item);
                      }
                    }}
                  >
                    {item?.linked_ee_ids?.includes(
                      selectedMainEEDetails?.ee_id,
                    ) ? (
                      <RemoveCircleOutlineIcon sx={{ fontSize: 15 }} />
                    ) : (
                      <ControlPointIcon sx={{ fontSize: 15 }} />
                    )}
                  </IconButton>
                </CustomToolTip>
              )}
            </Box>
          );
        }}
      />
      {/* Dialog for network interface selection */}
      <CustomDialogBoxV2
        open={networkDialogOpen}
        onClose={handleCloseNetworkInterface}
        title={"Network Interface"}
        actionButtonStyle="continuous"
        successButtonName="Confirm"
        onClickSuccess={() => handleNetworkInterfaceSelect(selectedNetworkItem)}
        rejectButtonName={"Cancel"}
        onClickReject={handleCloseNetworkInterface}
        onDisabled={!selectedNetworkInterface}
      >
        <Box sx={{ width: "350px" }}>
          <Stack spacing={2}>
            {networkInterfacesEE?.length > 0 ? (
              <>
                <Stack>
                  <CustomSelectV2
                    label={"Select The Interface"}
                    optionsList={networkInterfacesEE.map((ni) => ({
                      label: ni.name,
                      value: ni.name,
                    }))}
                    selectedValue={selectedNetworkInterface}
                    handleOnChange={(e) => {
                      setSelectedNetworkInterface(e.target.value);
                    }}
                    required={true}
                    // showLabel={false}
                    placeholder={false}
                  />
                </Stack>
              </>
            ) : (
              <Typography sx={{ ...componentStyle.font.cardText }}>
                No network interfaces available.
              </Typography>
            )}
          </Stack>
        </Box>
      </CustomDialogBoxV2>

      {/* Dialog for action type 1 - ECU to ECU linking */}
      <CustomDialogBoxV2
        open={dialogOpen}
        onClose={handleDialogClose}
        title={"Action"}
        actionButtonStyle="continuous"
        successButtonName={"Yes"}
        onClickSuccess={() => confirmUpdateAndRedirect()}
        onClickReject={updateChangesAndClose}
        rejectButtonName={"No"}
      >
        <Box sx={{ width: "350px", height: "50px" }}>
          <Typography>
            Are you sure the dependency linking of EE Component is completed?
          </Typography>
        </Box>
      </CustomDialogBoxV2>

      <CustomDialogBoxV2
        open={actionType2DialogOpen}
        onClose={handleActionType2DialogClose}
        title={"Action"}
        actionButtonStyle="continuous"
        successButtonName={"Link Now"}
        onClickSuccess={handleRedirectionToTypeApproval}
        onClickReject={handleActionType2DialogClose}
        rejectButtonName={"Link Later"}
      >
        <Box sx={{ width: "350px", height: "50px" }}>
          <Typography>EE Component intersection linking is pending!</Typography>
        </Box>
      </CustomDialogBoxV2>
      <CustomDialogBoxV2
        open={pendingEEActionDialogOpen}
        onClose={handlePendingEEActionDialogClose}
        title={"Action"}
        actionButtonStyle="continuous"
        successButtonName={"Link Now"}
        onClickSuccess={handleRedirectionToEEComponents}
        onClickReject={handlePendingEEActionDialogClose}
        rejectButtonName={"Link Later"}
      >
        <Box sx={{ width: "350px", height: "50px" }}>
          <Typography>
            {Number(selectedPendingEEAction?.action_type) === 4
              ? "Action pending in EE Component Attribute"
              : "Action pending in EE Component Version"}
          </Typography>
        </Box>
      </CustomDialogBoxV2>
      {showSmartMatchDialog && componentToBeMatched?.length > 0 && (
        <AISuggestionDialogContainer
          open={openAISuggestion}
          onClose={() => setOpenAISuggestion(false)}
          entity={selectedEntity}
          onLinkRequest={handleOpenNetworkInterface}
          onUnlinkRequest={handleEEComponentUnLink}
        />
      )}

      {openEELinkRecreateDialog && (
        <RecreateLinkDialog
          open={openEELinkRecreateDialog}
          onClose={closeRecreateDialog}
          entity={"EE"}
          linkList={recreateEELinkList}
          handleLink={handleOnClickRecreateLink}
        />
      )}
      <ModuleViewMoreDialog
        isEEDialogOpen={isEEDialogOpen}
        toggleEEDialog={toggleEEDialog}
        selectedComponent={selectedComponent}
        linkApiProps={linkApiProps}
        apiAction={apiAction}
        apiDataKey={apiDataKey}
        type={moduleViewMoreType}
      />
    </Box>
  );
}

export default EELinkPage;
